module.exports = __webpack_public_path__ + "img/next_en.ee3ba099.png";